import React from 'react';
import { Home, Phone } from 'lucide-react';
import './NavBar.css';

export default function NavBar() {
  const scrollToQuote = () => {
    document.getElementById('quote-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="nav">
      <div className="nav-in">
        <div className="logo">
          <div className="logo-box">
            <Home size={18} color="#fff" strokeWidth={2} />
          </div>
          <div className="logo-text">
            My<span>Home</span>Warranty
          </div>
        </div>

        <div className="nav-links">
          <a href="#coverage">Coverage</a>
          <a href="#plans">Plans</a>
          <a href="#reviews">Reviews</a>
          <a href="#faq">FAQ</a>
          <a href="tel:18005550100" className="nav-phone">
            <Phone size={14} strokeWidth={2} />
            (800) 555-0100
          </a>
          <button className="nav-btn" onClick={scrollToQuote}>
            Get Free Quote
          </button>
        </div>
      </div>
    </nav>
  );
}
